/* Keep the existing app-managed TrustBoxes at stable homepage anchors.
 * Theme copies regenerate Shopify section IDs; these anchors do not.
 * This does not create widgets, change reviews or alter the app account.
 */
(() => {
  'use strict';
  if (window.FDMTrustpilotPositions) return;
  const positions = [
    ['5419b637fa0340045cd0c936', 'fdm-trustpilot-rating'],
    ['54ad5defc6454f065c28af8b', 'fdm-trustpilot-reviews']
  ];
  let scheduled = false;
  function positionWidgets() {
    scheduled = false;
    for (const [template, anchorId] of positions) {
      const anchor = document.getElementById(anchorId);
      if (!anchor) continue;
      const widgets = document.querySelectorAll('.trustpilot-widget[data-template-id="' + template + '"]');
      for (const widget of widgets) {
        const wrapper = widget.closest('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]');
        if (!wrapper || wrapper.parentElement === anchor || wrapper.contains(anchor)) continue;
        anchor.appendChild(wrapper);
      }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(positionWidgets);
  }
  const observer = new MutationObserver(schedule);
  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    observer.disconnect();
    observer.observe(main, { childList: true, subtree: true });
    positionWidgets();
  }
  window.FDMTrustpilotPositions = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pageshow', schedule);
})();
